module.exports = __webpack_public_path__ + "img/download.356f5c19.svg";